// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/inventory.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/inventory.proto.
 */
export const file_chalk_server_v1_inventory: GenFile = /*@__PURE__*/
  fileDesc("Ch9jaGFsay9zZXJ2ZXIvdjEvaW52ZW50b3J5LnByb3RvEg9jaGFsay5zZXJ2ZXIudjEiHAoaR2V0VGVhbU5hdmJhckNvdW50c1JlcXVlc3QipQEKG0dldFRlYW1OYXZiYXJDb3VudHNSZXNwb25zZRIQCghwcm9qZWN0cxgBIAEoAxIQCghhY2NvdW50cxgCIAEoAxIQCghjbHVzdGVycxgDIAEoAxISCgpyZWdpc3RyaWVzGAQgASgDEhEKBHZwY3MYBSABKANIAIgBARIUCgdzdG9yYWdlGAYgASgDSAGIAQFCBwoFX3ZwY3NCCgoIX3N0b3JhZ2UiHwodR2V0UHJvamVjdE5hdmJhckNvdW50c1JlcXVlc3Qi+gQKHkdldFByb2plY3ROYXZiYXJDb3VudHNSZXNwb25zZRIRCglyZXNvbHZlcnMYASABKAMSEAoIZmVhdHVyZXMYAiABKAMSFQoNbmFtZWRfcXVlcmllcxgDIAEoAxIgChhhY3RpdmVfc2NoZWR1bGVkX3F1ZXJpZXMYBCABKAMSFgoOc2NhbGluZ19ncm91cHMYBSABKAMSFgoKY29udGFpbmVycxgGIAEoA0ICGAESEQoJc2FuZGJveGVzGBQgASgDEhEKCW5vdGVib29rcxgHIAEoAxIRCglmdW5jdGlvbnMYCCABKAMSEQoJc25hcHNob3RzGAkgASgDEhgKEG5vdGVib29rX2tlcm5lbHMYFSABKAMSDgoGaW1hZ2VzGBYgASgDEg4KBm1vZGVscxgKIAEoAxIZChFtb2RlbF9kZXBsb3ltZW50cxgYIAEoAxIWCg5vcGVuX2luY2lkZW50cxgLIAEoAxIQCgh3ZWJob29rcxgMIAEoAxIUCgxpbnRlZ3JhdGlvbnMYDSABKAMSDwoHc2VjcmV0cxgOIAEoAxIhChlvZmZsaW5lX3N0b3JlX2Nvbm5lY3Rpb25zGA8gASgDEhUKDW5hbWVkX3Byb21wdHMYECABKAMSFQoNb25saW5lX3N0b3JlcxgRIAEoAxIYChB2ZWN0b3JfZGF0YWJhc2VzGBIgASgDEhgKEGNvbmZpZ192YXJpYWJsZXMYEyABKAMSEwoLZXZhbHVhdGlvbnMYFyABKAMSFQoNYWNjZXNzX3Rva2VucxgeIAEoAxIWCg5haV9jb25uZWN0aW9ucxgfIAEoAxIPCgdidWNrZXRzGCAgASgDMpACChBJbnZlbnRvcnlTZXJ2aWNlEngKE0dldFRlYW1OYXZiYXJDb3VudHMSKy5jaGFsay5zZXJ2ZXIudjEuR2V0VGVhbU5hdmJhckNvdW50c1JlcXVlc3QaLC5jaGFsay5zZXJ2ZXIudjEuR2V0VGVhbU5hdmJhckNvdW50c1Jlc3BvbnNlIgaQAgGAfQISgQEKFkdldFByb2plY3ROYXZiYXJDb3VudHMSLi5jaGFsay5zZXJ2ZXIudjEuR2V0UHJvamVjdE5hdmJhckNvdW50c1JlcXVlc3QaLy5jaGFsay5zZXJ2ZXIudjEuR2V0UHJvamVjdE5hdmJhckNvdW50c1Jlc3BvbnNlIgaQAgGAfQJCFFoSc2VydmVyL3YxO3NlcnZlcnYxYgZwcm90bzM", [file_chalk_auth_v1_permissions]);

/**
 * Counts for the Team Navbar badges.
 *
 * @generated from message chalk.server.v1.GetTeamNavbarCountsRequest
 */
export type GetTeamNavbarCountsRequest = Message<"chalk.server.v1.GetTeamNavbarCountsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetTeamNavbarCountsRequest.
 * Use `create(GetTeamNavbarCountsRequestSchema)` to create a new message.
 */
export const GetTeamNavbarCountsRequestSchema: GenMessage<GetTeamNavbarCountsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_inventory, 0);

/**
 * @generated from message chalk.server.v1.GetTeamNavbarCountsResponse
 */
export type GetTeamNavbarCountsResponse = Message<"chalk.server.v1.GetTeamNavbarCountsResponse"> & {
  /**
   * @generated from field: int64 projects = 1;
   */
  projects: bigint;

  /**
   * Linked cloud account credentials (Cloud Accounts page), not platform users.
   *
   * @generated from field: int64 accounts = 2;
   */
  accounts: bigint;

  /**
   * @generated from field: int64 clusters = 3;
   */
  clusters: bigint;

  /**
   * @generated from field: int64 registries = 4;
   */
  registries: bigint;

  /**
   * Admin-only: unset (not 0) for non-admins, so the client can tell "0" apart
   * from "not authorized".
   *
   * @generated from field: optional int64 vpcs = 5;
   */
  vpcs?: bigint;

  /**
   * @generated from field: optional int64 storage = 6;
   */
  storage?: bigint;
};

/**
 * Describes the message chalk.server.v1.GetTeamNavbarCountsResponse.
 * Use `create(GetTeamNavbarCountsResponseSchema)` to create a new message.
 */
export const GetTeamNavbarCountsResponseSchema: GenMessage<GetTeamNavbarCountsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_inventory, 1);

/**
 * Counts for the Project Navbar and Settings sub-navbar badges. One RPC because
 * the Settings entities are environment-scoped and the panel pops out of the
 * project navbar.
 *
 * @generated from message chalk.server.v1.GetProjectNavbarCountsRequest
 */
export type GetProjectNavbarCountsRequest = Message<"chalk.server.v1.GetProjectNavbarCountsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetProjectNavbarCountsRequest.
 * Use `create(GetProjectNavbarCountsRequestSchema)` to create a new message.
 */
export const GetProjectNavbarCountsRequestSchema: GenMessage<GetProjectNavbarCountsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_inventory, 2);

/**
 * --- Project navbar ---
 *
 * @generated from message chalk.server.v1.GetProjectNavbarCountsResponse
 */
export type GetProjectNavbarCountsResponse = Message<"chalk.server.v1.GetProjectNavbarCountsResponse"> & {
  /**
   * From the environment's active deployment.
   *
   * @generated from field: int64 resolvers = 1;
   */
  resolvers: bigint;

  /**
   * @generated from field: int64 features = 2;
   */
  features: bigint;

  /**
   * Distinct named query names across all deployments (matches the
   * named-queries list).
   *
   * @generated from field: int64 named_queries = 3;
   */
  namedQueries: bigint;

  /**
   * Scheduled queries, scheduled resolvers, and scheduled aggregate backfills
   * in the active deployment (matches "Schedules"; run history excluded).
   *
   * @generated from field: int64 active_scheduled_queries = 4;
   */
  activeScheduledQueries: bigint;

  /**
   * Compute resources.
   *
   * @generated from field: int64 scaling_groups = 5;
   */
  scalingGroups: bigint;

  /**
   * @generated from field: int64 containers = 6 [deprecated = true];
   * @deprecated
   */
  containers: bigint;

  /**
   * @generated from field: int64 sandboxes = 20;
   */
  sandboxes: bigint;

  /**
   * @generated from field: int64 notebooks = 7;
   */
  notebooks: bigint;

  /**
   * @generated from field: int64 functions = 8;
   */
  functions: bigint;

  /**
   * @generated from field: int64 snapshots = 9;
   */
  snapshots: bigint;

  /**
   * @generated from field: int64 notebook_kernels = 21;
   */
  notebookKernels: bigint;

  /**
   * @generated from field: int64 images = 22;
   */
  images: bigint;

  /**
   * Environment registry models (environment-scoped, not deployment-scoped).
   *
   * @generated from field: int64 models = 10;
   */
  models: bigint;

  /**
   * Non-deleted model deployments in the environment, matching the list page.
   *
   * @generated from field: int64 model_deployments = 24;
   */
  modelDeployments: bigint;

  /**
   * @generated from field: int64 open_incidents = 11;
   */
  openIncidents: bigint;

  /**
   * @generated from field: int64 webhooks = 12;
   */
  webhooks: bigint;

  /**
   * @generated from field: int64 integrations = 13;
   */
  integrations: bigint;

  /**
   * 0 when the caller lacks PERMISSION_SECRETS_LIST.
   *
   * @generated from field: int64 secrets = 14;
   */
  secrets: bigint;

  /**
   * @generated from field: int64 offline_store_connections = 15;
   */
  offlineStoreConnections: bigint;

  /**
   * @generated from field: int64 named_prompts = 16;
   */
  namedPrompts: bigint;

  /**
   * online_stores/vector_databases are single configs today, so each is 0 or 1.
   *
   * @generated from field: int64 online_stores = 17;
   */
  onlineStores: bigint;

  /**
   * @generated from field: int64 vector_databases = 18;
   */
  vectorDatabases: bigint;

  /**
   * @generated from field: int64 config_variables = 19;
   */
  configVariables: bigint;

  /**
   * Volumes intentionally have no count: they are live cluster state served by
   * an in-cluster proxy, so counting them here would put a cross-cluster call
   * on every navbar load.
   *
   * @generated from field: int64 evaluations = 23;
   */
  evaluations: bigint;

  /**
   * Environment-scoped service tokens.
   *
   * @generated from field: int64 access_tokens = 30;
   */
  accessTokens: bigint;

  /**
   * @generated from field: int64 ai_connections = 31;
   */
  aiConnections: bigint;

  /**
   * Matches the Buckets settings page (typed bucket fields + env vars).
   *
   * @generated from field: int64 buckets = 32;
   */
  buckets: bigint;
};

/**
 * Describes the message chalk.server.v1.GetProjectNavbarCountsResponse.
 * Use `create(GetProjectNavbarCountsResponseSchema)` to create a new message.
 */
export const GetProjectNavbarCountsResponseSchema: GenMessage<GetProjectNavbarCountsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_inventory, 3);

/**
 * @generated from service chalk.server.v1.InventoryService
 */
export const InventoryService: GenService<{
  /**
   * Admin-only counts (VPCs, Storage) are unset for non-admins.
   *
   * @generated from rpc chalk.server.v1.InventoryService.GetTeamNavbarCounts
   */
  getTeamNavbarCounts: {
    methodKind: "unary";
    input: typeof GetTeamNavbarCountsRequestSchema;
    output: typeof GetTeamNavbarCountsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.InventoryService.GetProjectNavbarCounts
   */
  getProjectNavbarCounts: {
    methodKind: "unary";
    input: typeof GetProjectNavbarCountsRequestSchema;
    output: typeof GetProjectNavbarCountsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_inventory, 0);

